<template>
    <div class="wrapper">
        <div>
            <img @click="$router.push('/')" class="logo-img" :src="`${localUtil.imgUrl}home/logo-with-text.png`" />
        </div>
        <div>
            <div class="searchBox">
                <div class="searchItem">
                    <Icon class="iconFont" type="ios-search" :size="30" color="#f39b43"></Icon>
                    <input v-model="searchword"/>
                </div>
                <p @click="doSearch">搜索</p>
            </div>
            <ul class="types">
                <li v-for="keyword in keywords" :key="keyword.key" @click="clickKeyword(keyword.key)">{{keyword.text}}</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            searchTextShow: false,
            keywords: [
                { key: 'nine_foots', text: '九脚托盘' },
                { key: 'cuan-shaped', text: '川字托盘' },
                { key: 'grid-shaped', text: '田字托盘' },
                { key: 'plastic_basket', text: '周转筐' },
            ],
            searchword: ''
        }
    },
    methods: {
        clickKeyword(keyword) {
            this.$store.commit('mall/clickKeyword', keyword);

            if (this.$route.path != '/mall')
                this.$router.push('/mall');
        },
        doSearch() {
            this.$store.commit('mall/setSearchword', this.searchword);

            if (this.$route.path != '/mall')
                this.$router.push('/mall');
        }
    }
}
</script>

<style lang="less" scoped>
.wrapper {
    width: 1080px;
    display: flex;
    margin-top: 30px;
    // height: 57px;
    justify-content: space-between;
    background: #fff;
    div:nth-child(2) {
        position: relative;
        .iconFont {
            position: absolute;
            left: 12px;
            top: 5px;
        }
    }
    .searchBox {
        width: 393px;
        height: 38px;
        color: #f39b43;
        display: flex;
        position: relative;
        .searchItem {
            width: 313px;
            border: 2px solid #f39b43;
            border-radius: 20px 0 0 20px;
            input {
                width: 308px;
                height: 34px;
                outline: none;
                border: 1px solid transparent;
                border-radius: 20px;
                padding-left: 38px;
            }
        }
        p {
            width: 80px;
            height: 38px;
            background: #ff9000;
            border-radius: 0 18px 18px 0px;
            color: #fff;
            line-height: 36px;
            text-align: center;
            font-size: 16px;
            cursor: pointer;
            &:hover {
                opacity: 0.8;
            }
        }
    }
    .types {
        margin-top: 8px;
        list-style: none;
        li {
            float: left;
            margin-left: 20px;
            &:hover {
                cursor: pointer;
                color: #ff9000;
            }
        }
    }
}
.logo-img:hover {
    cursor: pointer;
}
</style>
